import { Injectable } from '@angular/core';
import { OktaAuthService } from '../../core/services/http/okta-auth.service';
import { IdleUserSignOutModalService } from '../modal/idle-user-sign-out-modal.service';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { readFromStorage, writeToStorage } from 'src/app/shared/utils/local-storage.utils';
import { activeInstanceIdStorageKey } from 'src/app/shared/constants/instance-storage-keys';

@Injectable({
    providedIn: 'root'
})
export class IdleUserSignOutTimerService {
    idleTimeout: any;
    warningModalActive = false;

    constructor(
        private oktaAuthService: OktaAuthService,
        private idleUserSignOutModalService: IdleUserSignOutModalService,
        private idleDetector: Idle
    ) {}

    start(timeoutInSeconds: number, warningTimeoutInSeconds: number, instanceId: string): void {
        this.idleDetector.setIdle(timeoutInSeconds);
        this.idleDetector.setTimeout(warningTimeoutInSeconds);
        this.idleDetector.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idleDetector.onInterrupt.subscribe(() => writeToStorage(activeInstanceIdStorageKey, instanceId));

        // Show warning dialog on idle user
        this.idleDetector.onIdleStart.subscribe(() => {
            if (!this.warningModalActive && readFromStorage(activeInstanceIdStorageKey) == instanceId) {
                this.onIdleElapsed(timeoutInSeconds, warningTimeoutInSeconds);
            }
        });

        // Jump straight to signout if timeout is exceeded (e.g. tab/computer went to sleep)
        this.idleDetector.onTimeout.subscribe(() => this.signOutIdleUser());

        this.idleDetector.watch();
    }

    onIdleElapsed(timeoutInSeconds: number, warningTimeoutInSeconds: number) {
        this.warningModalActive = true;
        this.idleUserSignOutModalService.open(warningTimeoutInSeconds * 1000).subscribe(result => {
            this.warningModalActive = false;

            if (result) {
                console.log(
                    `Logging user out due to inactivity. The user has been inactive for ${
                        timeoutInSeconds + warningTimeoutInSeconds
                    } second(s)`
                );
                console.log(`Idle log out triggered on ${new Date()}`);
                this.signOutIdleUser();
            }
        });
    }

    signOutIdleUser() {
        this.warningModalActive = false;
        this.oktaAuthService.signOut(window.location.href);
    }
}
